import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserListPage from "./pages/UserListPage";
import CompanyDataPage from "./pages/CompanyDataPage";
import UsersByDbPage from "./pages/UsersByDbPage";
import TenantByUserPage from "./pages/TenantByUserPage";
import UsersByTenantPage from "./pages/UsersByTenantPage";
import InvitationsByTenantPage from "./pages/InvitationsByTenantPage";
import CompaniesByTenantPage from "./pages/CompaniesByTenantPage";
import TransactionsPage from "./pages/admin/TransactionsPage";
import MerchantsPage from "./pages/admin/MerchantsPage";
import TransactionPage from "./pages/admin/TransactionPage";
import MerchantForm from "./pages/admin/MerchantForm";
import MerchantCouponsPage from "./pages/admin/MerchantCouponsPage";
import UsedCoupons from "./pages/admin/UsedCoupons";
import { CouponEditForm } from "./pages/admin/CouponEditForm";
import { NewCouponForm } from "./pages/admin/NewCouponForm";
import AuthCustomerSvc from "./authCustomerSvc";
import AuthKulcsUzlet from "./authKulcsUzlet";
import KPIPage from "./pages/admin/KPIPage";
import ApprenticeWizardsPage from "./pages/admin/ApprenticeWizardsPage";
import { ConnectAdminPage } from "./pages/admin/connect-page/ConnectAdminPage";
import { M2MAdminPage } from "./pages/admin/m2m-page/M2MAdminPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <AuthCustomerSvc>
              <UserListPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/company-data/:id"
          element={
            <AuthCustomerSvc>
              <CompanyDataPage />
            </AuthCustomerSvc>
          }
        />

        <Route
          path="/users-by-guid/:id"
          element={
            <AuthCustomerSvc>
              <UsersByDbPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/adatpont-tenants"
          element={
            <AuthCustomerSvc>
              <TenantByUserPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/adatpont-users"
          element={
            <AuthCustomerSvc>
              <UsersByTenantPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/admin/transactions"
          element={
            <AuthKulcsUzlet>
              <TransactionsPage />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/connect"
          element={
            <AuthCustomerSvc>
              <ConnectAdminPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/admin/kpi"
          element={
            <AuthKulcsUzlet>
              <KPIPage />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/apprenticeWizards"
          element={
            <AuthKulcsUzlet>
              <ApprenticeWizardsPage />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/transactions/:transactionid"
          element={
            <AuthKulcsUzlet>
              <TransactionPage />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/merchants"
          element={
            <AuthKulcsUzlet>
              <MerchantsPage />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/m2m"
          element={
            <AuthCustomerSvc>
              <M2MAdminPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/adatpont-invitations"
          element={
            <AuthCustomerSvc>
              <InvitationsByTenantPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/adatpont-companies"
          element={
            <AuthCustomerSvc>
              <CompaniesByTenantPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/admin/trader/create"
          element={
            <AuthKulcsUzlet>
              <MerchantForm />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/trader/edit/:id"
          element={
            <AuthKulcsUzlet>
              <MerchantForm />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/trader/:id/coupons"
          element={
            <AuthCustomerSvc>
              <MerchantCouponsPage />
            </AuthCustomerSvc>
          }
        />
        <Route
          path="/admin/coupon/:id/edit"
          element={
            <AuthKulcsUzlet>
              <CouponEditForm />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/trader/:id/coupon/create"
          element={
            <AuthKulcsUzlet>
              <NewCouponForm />
            </AuthKulcsUzlet>
          }
        />
        <Route
          path="/admin/trader/:id/relation"
          element={
            <AuthKulcsUzlet>
              <UsedCoupons />
            </AuthKulcsUzlet>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
